export const InputOutlinedDefaultBorders =
  "rounded border border-inside border-slate-200 dark:border-slate-700 dark:hover:border-slate-700";

export const InputOutlinedDefault =
  InputOutlinedDefaultBorders +
  " bg-white dark:bg-slate-900 dark:hover:bg-slate-800 hover:bg-gray-100 dark:active:bg-slate-700 active:bg-gray-200";

export const InputOutlinedHighlight =
  "rounded border dark:hover:border-slate-700 bg-slate-50 dark:bg-slate-950 bg-opacity-75 border-slate-200 dark:border-slate-900 hover:bg-slate-50 active:bg-slate-50 dark:hover:bg-slate-950 dark:active:bg-slate-950";
